var exports = {
  "k": "x127c5a35--8c3124--container",
  "Q": "x127c5a35--8c3124--text",
};

module.exports = exports;
